function initMenuMobileNavigation() {
    let isNavigationInitialized = false;
    const links = Array.from(document.querySelectorAll('.menu-mobile-navigation li') || []);
    links.forEach(link => {
        link.addEventListener('click', function () {
            links.forEach(link => link.classList.remove('active-link'));
            this.classList.add('active-link');

            const query = `.nav.main-nav li.${link.dataset.link}.has-children a`;
            const fallbackQuery = `.nav.main-nav li.${link.dataset.link} a`;
            const anchor = document.querySelector(query) || document.querySelector(fallbackQuery);

            if (anchor) {
                anchor.click();
            }
        });
    });

    if (!isNavigationInitialized) {

        setTimeout(() => {
            links[0].click();
            isNavigationInitialized = true;
        }, 500);
    }

}

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
        initMenuMobileNavigation();
    }, 1000);
});